import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Can } from '../Can';

const useStyles = makeStyles(() => ({
  root: {}
}));

const PageHeader = (props: { className?: string, section: string, title: string, action?: { permission?: string, route?: string, onClick?: () => void, label: string } }) => {
  const {className, section, title, action, ...rest} = props;

  const classes = useStyles();

  return (
    <div{...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="flex-end"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid item>
          <Typography component="h2" gutterBottom variant="overline">{section}</Typography>
          <Typography component="h1" variant="h3">{title}</Typography>
        </Grid>
        {action && (
          <Can permission={action.permission}>
            <Grid item>
              {action.route && (
                <Button
                  color="primary"
                  variant="contained"
                  component={RouterLink}
                  to={action.route}>
                  {action.label}
                </Button>
              )}
              {action.onClick && (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={action.onClick}
                >
                  {action.label}
                </Button>
              )}
            </Grid>
          </Can>
        )}
      </Grid>
    </div>
  );
};

export default PageHeader;
